<form class="routed-component-layout" (ngSubmit)="onSubmit()" [formGroup]="form" novalidate>

  <div class="routed-component-body">
    <div class="routed-component-title-block">

      <h2>{{ "REGISTRATION.DIRECTOR.TITLE" | translate }}</h2>
      <h5>{{ "REGISTRATION.DIRECTOR.LEGAL_REPRESENTATIVE_DEFINITION"  | translate }}</h5>

    </div>


    <h4>{{ 'REGISTRATION.DIRECTOR.ARE_YOU_REPRESENTATIVE' | translate }}</h4>

    <soldo-field-layout
      [control]="form.controls.applicantIsLegalRep"
      fieldName="applicantIsLegalRep"
      cypressSelector="Director_RadioButton_IsLeadDirector">

      <fieldset input class="field-group-layout">
        <div data-cy="Director_RadioButton_IsLeadDirector_TRUE">
          <input id="YES-lead" type="radio" name="directorChoice" [formControl]="form.controls.applicantIsLegalRep" [value]="LEGAL_REP_CHOICE.APPLICANT">
          <label for="YES-lead">{{ "REGISTRATION.DIRECTOR.APPLICANT_IS_LEGAL_REP" | translate: {firstName: applicantContact.firstName, lastName: applicantContact.lastName } }}</label>
        </div>
        <div data-cy="Director_RadioButton_IsLeadDirector_FALSE">
          <input id="NO-lead" type="radio" name="directorChoice" [formControl]="form.controls.applicantIsLegalRep" [value]="LEGAL_REP_CHOICE.OTHER">
          <label for="NO-lead">{{ "REGISTRATION.DIRECTOR.APPLICANT_IS_NOT_LEGAL_REP" | translate }}</label>
        </div>
      </fieldset>

      <ng-container errorMessage>
        <soldo-field-error error errorName="required">{{ 'REQUIRED' | translate }}</soldo-field-error>
      </ng-container>
    </soldo-field-layout>

    <div class="callout informative">
      <div class="callout-content">
        <p>{{ "REGISTRATION.DIRECTOR.CALLOUT_PARAGRAPH" | translate: {regulatoryInstitution: regulatoryInstitution} }}</p>
        <a [href]="registrationProcessURL" tabindex="0" target="_blank">{{ "REGISTRATION.DIRECTOR.CALLOUT_LINK" | translate }}</a>
      </div>
    </div>

    <div class="field-group-layout" *ngIf="form.value.applicantIsLegalRep !== LEGAL_REP_CHOICE.NO_CHOICE">
      <h4>{{ "REGISTRATION.DIRECTOR.FORM_TITLE" | translate }}</h4>
      <person-form
        [personFormGroup]="form.controls.legalRep"
        [applyUniquenessChecks]="true"
        [checkInArray]="contactsDTO"
        [emailIsReadonly]="form.value.applicantIsLegalRep === LEGAL_REP_CHOICE.APPLICANT"
        [translatedCountries]="translatedCountries"></person-form>
    </div>
    </div>
      <div class="navigation-controls-layout">
        <div class="routed-component-cta">
          <button type="button" (click)="goToPrevious()" data-cy="Button_StepBackButton">
            {{ 'PREVIOUS' | translate}}
          </button>

          <button type="submit" class="primary" [disabled]="loading" [ngClass]="{ 'loading': loading}" data-cy="Button_StepSubmitButton">
            {{ 'NEXT' | translate}}
          </button>
      </div>
      <save-and-continue-later stepName="Director Details"></save-and-continue-later>
    </div>
</form>
